import React from 'react'
import { PlanSeq } from '@mobi/api-types'
import { Banner } from '@mobi/component-library/Feedback/Banner'
import type { Ticket, TicketStatus } from '@core/Areas/Account/Pages/Activity/types'
import type { BetLoopShareTicket } from '@core/Areas/BetLoop/types'
import type { TicketLayoutType } from '../../helpers/legTypes'
import {
  FavouriteNumbers,
  Multi,
  SameRaceMulti,
  SingleMultiple,
  SingleSingle,
  Sports,
  Tipping,
} from './Components'

export const BetInfo: React.FC<{
  ticket: Ticket | BetLoopShareTicket
  status: TicketStatus
  ticketLayoutType: TicketLayoutType
}> = ({ ticket, status, ticketLayoutType }) => {
  if (PlanSeq.FavouriteNumbers === ticket.planSeq) {
    return <FavouriteNumbers ticket={ticket} status={status} />
  }

  if (ticketLayoutType === 'same-race-multi') {
    return <SameRaceMulti ticket={ticket} status={status} />
  }

  if (ticketLayoutType === 'single-single') {
    return <SingleSingle ticket={ticket} status={status} />
  }

  if (ticketLayoutType === 'single-multiple') {
    return <SingleMultiple ticket={ticket} status={status} />
  }

  if (ticketLayoutType === 'multi') {
    return <Multi ticket={ticket} status={status} />
  }

  if (ticketLayoutType == 'tipping') {
    return <Tipping ticket={ticket} status={status} />
  }

  if (ticketLayoutType === 'sports') {
    return <Sports ticket={ticket} status={status} />
  }

  return <Banner text='Unable to match selection info' type='neutral' />
}

BetInfo.displayName = 'BetInfo'
